import type { VirtuosoHandle } from "react-virtuoso";
import type { ChatListItem } from "./flattenForVirtuoso";
import { findMessageIndex } from "./flattenForVirtuoso";

/** Scroll to a message by chat_id using Virtuoso's scrollToIndex */
export function scrollToMessage(
  virtuosoRef: React.RefObject<VirtuosoHandle>,
  flatChatList: ChatListItem[],
  chatId: string,
): boolean {
  const index = findMessageIndex(flatChatList, chatId);
  if (index === -1) return false;

  virtuosoRef.current?.scrollToIndex({
    index,
    align: "start",
    behavior: "smooth",
  });
  return true;
}
